import SoundManager from "../../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import RevisableLanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import ChatNpcMessageEvent from "../../../chat/events/ChatNpcMessageEvent";
import ChatModel from "../../../chat/model/ChatModel";
import EmailAddedEvent from "../../../email/model/EmailAddedEvent";
import EmailConversationStatusChangedEvent from "../../../email/model/EmailConversationStatusChangedEvent";
import EmailModel from "../../../email/model/EmailModel";
import SmartphoneSkinKeyRegistry from "../../model/SmartphoneSkinKeyRegistry";
import AbstractSmartphoneMediator from "../AbstractSmartphoneMediator";

export default class SmartphoneMainScreenMediator extends AbstractSmartphoneMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SoundManager} soundManager 
     * @param {EmailModel} emailModel 
     * @param {ChatModel} chatModel 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, soundManager, emailModel, chatModel, languagePack) {
        super(target, dispatcher);

        this._soundManager = soundManager;
        this._emailModel = emailModel;
        this._chatModel = chatModel;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this.registerEventListener(EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION, this.updateIndicators.bind(this));
        this.registerEventListener(EmailConversationStatusChangedEvent.STATUS_CHANGED, this.updateIndicators.bind(this));
        this.registerEventListener(ChatNpcMessageEvent.SENT, this.updateIndicators.bind(this));

        this.initializeButtons();
        this.updateIndicators();
    }

    initializeButtons() {
        if (this._target.emailButton) {
            this.createInterfaceButton(this._target.emailButton, _ => {
                this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_EMAIL_BOX_SELECTION_SCREEN_SKIN);
            });
        }

        if (this._target.smsButton) {
            this.createInterfaceButton(this._target.smsButton, _ => {
                this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_CHAT_CONTACTS_SCREEN_SKIN);
            });
        }
    }

    updateIndicators() {
        if (this._target.emailButton) {
            const unreadCount = this._emailModel.getUnreadCount();
            const unreadCountString = unreadCount.toString();
            this._target.emailButton.newIndicator.gotoAndStop(unreadCountString.length > 1 ? 1 : 0);
            this._target.emailButton.newIndicator.textField.text = unreadCountString;
            this._target.emailButton.newIndicator.visible = unreadCount > 0;
        }

        if (this._target.smsButton) {
            const unreadCount = this._chatModel.getUnreadCount();
            const unreadCountString = unreadCount.toString();
            this._target.smsButton.newIndicator.gotoAndStop(unreadCountString.length > 1 ? 1 : 0);
            this._target.smsButton.newIndicator.textField.text = unreadCountString;
            this._target.smsButton.newIndicator.visible = unreadCount > 0;
        }
    }
}